module.exports = __webpack_public_path__ + "img/Toyota_logo_300x300.0e107bd2.png";